exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mrK-JRBP_7bicAN2EQshr{color:#111;font-family:dosis, sans-serif;font-weight:400;text-align:justify;font-size:24px}@media (min-width: 480px){.mrK-JRBP_7bicAN2EQshr{font-size:25px}}@media (min-width: 640px){.mrK-JRBP_7bicAN2EQshr{font-size:26px}}@media (min-width: 1024px){.mrK-JRBP_7bicAN2EQshr{font-size:28px}}._3Y4xZE3iXOA1H4YF5PJ4Qq{color:#864551;font-weight:500}._3Y4xZE3iXOA1H4YF5PJ4Qq:hover{color:#974e5b}\n", ""]);
// Exports
exports.locals = {
	"main": "mrK-JRBP_7bicAN2EQshr",
	"link": "_3Y4xZE3iXOA1H4YF5PJ4Qq"
};